import React from 'react';
import { observer } from 'mobx-react';

import {
  Grid,
  Box
} from '@mui/material';

import useStyles from './header.styles';
import CommonImages from '../../../commons/images';
import BackMenuButton from './BackMenuButton';
 
function Header () {

  const classes = useStyles();
   
  return (
    <div className={classes.appBar}>
      <BackMenuButton />
      <Grid className={classes.barBody}>
        <img
          className={classes.logo}
          alt="MyEcal"
          src={CommonImages.ECAL_CALENDAR_CIRCLE}
        />

        <Box className={classes.myECALWord}>My ECAL</Box>
      </Grid>
    </div>
  );
}

export default observer(Header);
